import stateClass, {} from '../baseState';
import customConnect from '../customConnect';
import { setDataYear } from './actions';
import store from '../store';

var CHANGE_YEAR_EVENT = 'change_year_event';
var TOGGLE_ACTIVE = 'toogle_active';

class dataYearClass extends stateClass{
    
    constructor(props) {

        super(props);

        this.years = ['2015/2016', '2016/2017', '2017/2018'];
        this.activeYearIndex = 2;
    }

    toggleActive(active) {

        this.enabled = active;

        this.emit(TOGGLE_ACTIVE);
    }

    setActive(index) {

        this.activeYearIndex = index;

        this.emit(CHANGE_YEAR_EVENT);
    }

    getActive() {

        return this.years[this.activeYearIndex];
    }

    setActiveYear() {

        return this.years[this.activeYearIndex];
    }
}

var dataYearState = new dataYearClass;

dataYearState.on(CHANGE_YEAR_EVENT, () => {


    store.dispatch(setDataYear(dataYearState.getActive()));
})


//customConnect(mapStateToPropsRes, mapDispatchToPropsRes, store, stateUpdateHandler);

export {dataYearState, CHANGE_YEAR_EVENT}


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/dataYearState.js